import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-techblog-header',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './techblog-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './techblog-header.component.scss'
})
export class TechblogHeaderComponent {

}
